let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kWm96")).then(() => parcelRequire('2kjD7'));